import './App.css';
import Products from './Products';
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { FaInstagram, FaFacebook } from 'react-icons/fa';
import { motion } from 'framer-motion';
import OrderNowPage from './OrderNowPage';

const containerVariants = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.4, }, },
};

const itemVariants = {
    hidden: { opacity: 0, x: 20 },
    visible: { opacity: 1, x: 0, transition: { duration: 1.2, ease: 'easeOut', }, },
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/products" element={<Products />} />
        <Route path="/order-now" element={<OrderNowPage />} />
      </Routes>
    </Router>
  );
}


function LandingPage() {
  // Remove all modal-related state and handlers
  // Only keep the video, overlay, and order now button
  return (
    <div className="landing-page" style={{ minHeight: '100vh', position: 'relative', display: 'flex', flexDirection: 'column' }}>
      {/* Video Background */}
      <video autoPlay muted loop id="bg-video">
        <source src="/videos/mainbanner-bg.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay content */}
      <div className="overlay-content">
        <motion.img
          src="/images/pani-stamp-1000px-white.png"
          alt="Pani Eatery Logo"
          className="logo"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: 'easeOut' }}
        />
        <div className="social-icons">
          
          <a href="https://instagram.com/panieatery" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
          <a href="https://facebook.com/panieatery" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
        </div>
        
        {/* <Link to="/order-now" className="order-now-btn">
          Order Now
        </Link> */}
      </div>

      <div
        style={{
          position: 'absolute',
          bottom: '30px',
          right: '30px',
          textAlign: 'left',
          lineHeight: '1',
          color: '#fff',
        }}
      >
        <div className="fresh-text">
          Fresh.
        </div>
        <div className="homemade-text">
          Homemade.
        </div>
        <div className="delicious-text">
          delicious.
        </div>
      </div>

    {/* Footer absolutely at the bottom of the page */}
    <footer className="footer-info">
      {/*
        <div className="footer-info-text">
          <a
            href="/documents/pani-menu2025-july.pdf"
            className="menu-btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            See our Menu
          </a><br/>

          Tuesday to Friday from 4pm to 7pm. Saturday from 1pm to 7pm.<br/>
          Delivery available on Saturdays.<br/>

        </div>
      */}
    </footer>

  </div>
  );
}

export default App;